import React, { useState } from 'react';

export const cardStyle: React.CSSProperties = {
  background: 'rgba(13, 20, 40, 0.85)',
  backdropFilter: 'blur(20px)',
  border: '1px solid rgba(212, 175, 55, 0.12)',
  borderRadius: '24px',
  boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
  position: 'relative',
  overflow: 'hidden',
};

export const CardDecorations: React.FC = () => (
  <>
    <div style={{
      position: 'absolute',
      top: 0,
      left: '10%',
      right: '10%',
      height: '2px',
      background: 'linear-gradient(90deg, transparent, #d4af37, transparent)',
    }} />
    <div style={{
      position: 'absolute',
      inset: 0,
      borderRadius: '24px',
      background: 'linear-gradient(135deg, rgba(212,175,55,0.15), transparent 50%)',
      pointerEvents: 'none',
    }} />
  </>
);

export const goldShimmerKeyframes = `
  @keyframes goldShimmer {
    0%, 100% { background-position: 0% center; }
    50% { background-position: 200% center; }
  }
`;

export const headingStyle = (isMobile: boolean): React.CSSProperties => ({
  fontSize: isMobile ? '16px' : '20px',
  fontFamily: 'var(--font-display)',
  fontStyle: 'italic',
  color: '#f0f0f0',
  marginBottom: '20px',
  position: 'relative',
  zIndex: 1,
});

export const spinnerStyle: React.CSSProperties = {
  color: '#d4af37',
  textAlign: 'center',
  padding: '40px 20px',
  fontSize: '14px',
};

interface CollapsibleCardProps {
  title: string;
  defaultCollapsed?: boolean;
  padding?: string;
  marginBottom?: string;
  children: React.ReactNode;
}

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
  title,
  defaultCollapsed = false,
  padding,
  marginBottom = '24px',
  children,
}) => {
  const [collapsed, setCollapsed] = useState(defaultCollapsed);

  return (
    <div style={{
      ...cardStyle,
      padding: padding || '20px 16px',
      marginBottom,
    }}>
      <CardDecorations />
      <div
        onClick={() => setCollapsed(!collapsed)}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
          position: 'relative',
          zIndex: 1,
          marginBottom: collapsed ? 0 : '16px',
        }}
      >
        <h2 style={{ ...headingStyle(false), marginBottom: 0 }}>{title}</h2>
        <span style={{
          color: '#d4af37',
          fontSize: '18px',
          transition: 'transform 0.3s ease',
          transform: collapsed ? 'rotate(90deg)' : 'rotate(0deg)',
          userSelect: 'none',
        }}>▼</span>
      </div>
      {!collapsed && (
        <div style={{ position: 'relative', zIndex: 1 }}>
          {children}
        </div>
      )}
    </div>
  );
};
